<template>
  <div class="water-quality-container" :class="{ 'collapsed': isCollapsed }">
    <div class="water-quality-icon" v-if="isCollapsed" @click="toggleCollapse" title="水质监测">
      <img :src="waterQualityIcon" alt="水质监测" />
    </div>
    <div class="content" v-else>
      <div class="header">
        <Title :img="triangleImg" :name="'实时水质数据'" :callback="getWaterInfo" />
        <div class="toggle-btn" @click="toggleCollapse">
          <i class="toggle-icon" :class="isCollapsed ? 'down-icon' : 'up-icon'"></i>
        </div>
      </div>
      <div class="monitor-name">{{ currentData.name }}</div>
      <div class="data-grid">
        <div class="data-card">
          <div class="data-name">pH值</div>
          <div class="data-value" :class="getValueClass(currentData.pH, 'pH')">{{ currentData.pH }}</div>
          <div class="data-unit">pH</div>
        </div>
        <div class="data-card">
          <div class="data-name">浊度</div>
          <div class="data-value" :class="getValueClass(currentData.turbidity_NTU, 'turbidity')">{{
            currentData.turbidity_NTU }}</div>
          <div class="data-unit">NTU</div>
        </div>
        <div class="data-card">
          <div class="data-name">叶绿素a</div>
          <div class="data-value" :class="getValueClass(currentData.chlorophyll_a_ugL, 'chlorophyll')">{{
            currentData.chlorophyll_a_ugL }}</div>
          <div class="data-unit">μg/L</div>
        </div>
      </div>
    </div>
  </div>
  <WaterQualityDetail ref="waterquality" />
</template>

<script>
import Title from '@/components/title/title.vue'
import WaterQualityDetail from '@/page/water-quality/WaterQuality.vue'

export default {
  name: "WaterQuality",
  components: { 
    Title, 
    WaterQualityDetail
  },
  data() {
    return {
      currentIndex: 0,
      timer: null,
      triangleImg: require('@/assets/image/triangle.png'),
      waterQualityIcon: require('@/assets/image/water-quality-icon.png'),
      isCollapsed: false,
      waterInfo: [
        {
          id: 1,
          name: '水质监测点A',
          position: [121.60195806089678, 30.02454035771524],
          description: "清洁水体（低营养状态）",
          pH: 7.2,
          turbidity_NTU: 2.1,
          chlorophyll_a_ugL: 0.8,
          risk_level: "低",
          color: "#7bc043" // 绿色 - 良好
        },
        {
          id: 2,
          name: '水质监测点B',
          position: [121.60270936353521, 30.0245166040024],
          description: "轻度富营养化（藻类增殖）",
          pH: 8.5,
          turbidity_NTU: 15.3,
          chlorophyll_a_ugL: 6.4,
          risk_level: "中",
          color: "#f9a022" // 黄色 - 警告
        },
        {
          id: 3,
          name: '水质监测点C',
          position: [121.6020551393272,30.024995331580882],
          description: "重度富营养化（藻华爆发）",
          pH: 9.1,
          turbidity_NTU: 45.7,
          chlorophyll_a_ugL: 78.2,
          risk_level: "高",
          color: "#f65c5c" // 红色 - 危险
        }
      ]
    }
  },
  computed: {
    currentData() {
      return this.waterInfo[this.currentIndex];
    }
  },
  methods: {
    getWaterInfo() {
      this.$refs.waterquality && this.$refs.waterquality.open();
    },
    startRotation() {
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.waterInfo.length;
      }, 3000);
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      if (!this.isCollapsed) {
        this.$emit('water-data-ready', this.waterInfo);
      }
    },
    getValueClass(value, type) {
      // 根据不同类型的数据返回对应的样式类
      switch (type) {
        case 'pH':
          return value < 6.5 || value > 8.5 ? 'danger' :
            value < 7.0 || value > 8.0 ? 'warning' : 'good';
        case 'turbidity':
          return value > 30 ? 'danger' :
            value > 10 ? 'warning' : 'good';
        case 'chlorophyll':
          return value > 50 ? 'danger' :
            value > 5 ? 'warning' : 'good';
        default:
          return 'good';
      }
    }
  },
  mounted() {
    this.startRotation();
    this.$emit('water-data-ready', this.waterInfo);
  },
  watch: {
    waterInfo: {
      handler(newVal) {
        this.$emit('water-data-ready', newVal);
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>

<style lang="less" scoped>
.water-quality-container {
  position: absolute;
  right: 25%;
  bottom: 2rem;
  height: auto;
  max-height: calc(30% - 1rem);
  transition: all 0.3s ease;
  z-index: 250; /* 确保层级正确 */
  
  &.collapsed {
    height: auto;
    max-height: none;
    background: none;
    box-shadow: none;
    margin-right: 0;
    padding: 0;
    
    .water-quality-icon {
      width: 40px;
      height: 40px;
      cursor: pointer;
      border-radius: 50%;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      transition: transform 0.3s ease;
      margin-right: 10px;
      
      &:hover {
        transform: scale(1.1);
      }
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  
  .content {
    background:
      /* 左上角圆形渐变 */
      radial-gradient(circle at left top, #c8aca2, #171e2127 5%) no-repeat,
      /* 右上角圆形渐变 */
      radial-gradient(circle at right top, #c8aca2, #171e2127 5%) no-repeat,
      /* 中间半透明背景 */
      linear-gradient(to bottom, #171e2127, #171e2127);
    border-radius: 5px;
    padding: 0.5rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    width: 280px; /* 固定宽度，防止自动缩放 */
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .toggle-btn {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(160, 200, 226, 0.1);
      border-radius: 50%;
      cursor: pointer;
      color: #a0c8e2;
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(160, 200, 226, 0.3);
      }
      
      .toggle-icon {
        display: inline-block;
        width: 12px;
        height: 12px;
        position: relative;
        
        &.up-icon:before,
        &.down-icon:before {
          content: '';
          position: absolute;
          width: 8px;
          height: 8px;
          border-right: 2px solid #a0c8e2;
          border-bottom: 2px solid #a0c8e2;
          transform-origin: center;
        }
        
        &.up-icon:before {
          transform: rotate(-135deg);
          top: 4px;
        }
        
        &.down-icon:before {
          transform: rotate(45deg);
          top: 0;
        }
      }
    }
  }

  .monitor-name {
    color: #a0c8e2;
    font-size: 0.9rem;
    text-align: center;
    margin: 8px 0;
    padding: 4px;
    background: rgba(160, 200, 226, 0.1);
    border-radius: 4px;
    white-space: nowrap; /* 防止文字换行 */
    overflow: hidden;
    text-overflow: ellipsis; /* 文字过长时显示省略号 */
  }

  .data-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 5px; /* 减小间隔，确保不挤压 */

    .data-card {
      background-color: #22202034;
      border-radius: 5px;
      padding: 1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      transition: all 0.3s ease;

      .data-name {
        color: #a0c8e2;
        font-size: 0.85rem; /* 略微减小字体大小 */
        margin-bottom: 5px;
        white-space: nowrap; /* 防止文字换行 */
      }

      .data-value {
        font-size: 1.4rem; /* 略微减小字体大小 */
        font-weight: bold;
        transition: color 0.3s ease;
        white-space: nowrap; /* 防止文字换行 */

        &.good {
          color: #7bc043;
        }

        &.warning {
          color: #f9a022;
        }

        &.danger {
          color: #f65c5c;
        }
      }

      .data-unit {
        color: #a0c8e2;
        font-size: 0.75rem; /* 略微减小字体大小 */
        white-space: nowrap; /* 防止文字换行 */
      }
    }
  }
}
</style>